// haptics.ts

import { getTelegramWebApp } from "./telegram";

const HAPTIC_FEEDBACK_MIN_VERSION = "6.1";

export type HapticImpactStyle = Parameters<
    TelegramWebAppHapticFeedback["impactOccurred"]
>[0];

export type HapticNotificationType = Parameters<
    TelegramWebAppHapticFeedback["notificationOccurred"]
>[0];

function getHapticFeedback(): TelegramWebAppHapticFeedback | null {
    const webApp = getTelegramWebApp();
    if (!webApp?.isVersionAtLeast(HAPTIC_FEEDBACK_MIN_VERSION)) return null;
    return webApp.HapticFeedback ?? null;
}

let lastFeedbackAt: number | null = null;

function noteFeedback(): void {
    lastFeedbackAt = performance.now();
}

/** Telegram-native haptic feedback, with a safe no-op browser fallback. */
export const haptics = {
    isAvailable(): boolean {
        return getHapticFeedback() !== null;
    },

    impact(style: HapticImpactStyle): void {
        noteFeedback();
        getHapticFeedback()?.impactOccurred(style);
    },

    notification(type: HapticNotificationType): void {
        noteFeedback();
        getHapticFeedback()?.notificationOccurred(type);
    },

    selectionChanged(): void {
        noteFeedback();
        getHapticFeedback()?.selectionChanged();
    },

    /**
     * Milliseconds since anything was last emitted (Infinity if nothing was),
     * so incidental feedback can step aside for feedback that just played
     * rather than blur into it.
     */
    msSinceLastFeedback(): number {
        return lastFeedbackAt === null
            ? Number.POSITIVE_INFINITY
            : performance.now() - lastFeedbackAt;
    },
} as const;
